import { Outlet, createFileRoute } from "@tanstack/react-router";

import { useServer } from "@/components/server-hooks";
import { ServerSidebar } from "@/components/server-shell";

export const Route = createFileRoute("/_auth/servers/$id")({
  component: ServerLayout,
});

/** One server's workspace: the sidebar from the design canvas, then the page. */
function ServerLayout() {
  const { id } = Route.useParams();
  const q = useServer(id);
  return (
    <div className="flex min-h-svh flex-wrap bg-[#111111] text-[#ECEAE4]">
      <div className="flex-[1_1_240px] bg-[#0C0C0B] md:max-w-[260px]">
        <div className="md:sticky md:top-0 md:h-svh md:overflow-y-auto">
          <ServerSidebar id={id} />
        </div>
      </div>
      <main className="flex min-w-0 flex-[999_1_560px] flex-col">
        {q.error ? <p className="p-10 text-sm text-red-500">{q.error.message}</p> : <Outlet />}
      </main>
    </div>
  );
}
